import { render } from "./SimpleBarGraph.vue?vue&type=template&id=f6d66eba&scoped=true"
import script from "./SimpleBarGraph.vue?vue&type=script&lang=js"
export * from "./SimpleBarGraph.vue?vue&type=script&lang=js"

import "./SimpleBarGraph.vue?vue&type=style&index=0&id=f6d66eba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6d66eba"]])

export default __exports__